import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_DATA_PROVIDERS } from "../../routes";

export default function useGetDataProviders(auto = false) {
  const [dataProviders, setDataProviders] = useState([]);

  const getDataProviders = () => {
    Api.get(API_ROUTE_DATA_PROVIDERS).then((res) => {
      setDataProviders(res.data);
    });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getDataProviders();
  }, [auto]);

  return {
    dataProviders,
    getDataProviders,
  };
}
